import React from "react";
import axios from "axios";
import flatpickr from "flatpickr";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";
import Alert from "../Alert";
import { connect } from "react-redux";

class BusinessNoteReminderModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            noteShow: false,
            focused: false,
            note_text: "",
            loading: false,
            error: null
        };
    }

    safeSetState = (newState) => {
        if (this._isMounted) this.setState(newState);
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;

        const defaultDate = new Date();
        defaultDate.setDate(defaultDate.getDate() + 1);

        flatpickr(".js-datetimepicker", {
            altInput: true,
            altFormat: "F j, Y h:i K",
            dateFormat: "Z",
            minDate: new Date(),
            enableTime: true,
            allowInput: true,
            defaultDate,
            plugins: [new confirmDatePlugin({ showAlways: true })]
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.noteShow && this.state.noteShow) {
            setTimeout(() => {
                document.querySelector(".note-textarea")?.focus();
            }, 100);
        }
    }

    handleNoteTextChange = (e) => {
        this.safeSetState({ note_text: e.target.value });
    };

    handleSubmit = async () => {
        const datetime = document.querySelector(".js-datetimepicker")?.value;
        const via_email = document.querySelector(".modal-email-checkbox")?.checked;
        const via_text = document.querySelector(".modal-text-checkbox")?.checked;
        const via_push = document.querySelector(".modal-push-checkbox")?.checked;

        const { noteShow, note_text } = this.state;
        const { businessId, businessName, currentUser, currentUserId } = this.props;

        if (!via_email && !via_text && !via_push) {
            this.safeSetState({ error: __("Please select at least one notification method.") });
            return;
        }

        if (!datetime) {
            this.safeSetState({ error: __("Please select a reminder date and time.") });
            return;
        }

        const promises = [];

        this.safeSetState({ loading: true, error: null });

        try {
            if (noteShow && note_text.trim()) {
                promises.push(
                    axios.post("/business-notes", {
                        business_id: businessId,
                        // user_id: currentUser,
                        note: note_text.trim()
                    })
                );
            }

            promises.push(
                axios.post("/reminders", {
                    business_id: businessId,
                    recipients: [
                        {
                            "user_id": currentUserId,
                            "via_email": via_email,
                            "via_text": via_text,
                            "via_push": via_push
                        }
                    ],
                    remind_at: datetime,
                    title: `Reminder for ${businessName}`,
                    note: note_text.trim()
                })
            );

            await Promise.all(promises);

            this.props.onSaved?.();
        } catch (err) {
            this.safeSetState({ error: __("Something went wrong while saving the reminder or note.") });
        } finally {
            this.safeSetState({ loading: false });
        }
    };

    handleCancel = () => {
        this.props.onClose?.();
    };

    handleContinueWithoutReminder = async () => {
        const { noteShow, note_text } = this.state;
        const businessId = this.props?.businessId;

        if (!noteShow || !note_text.trim()) {
            this.safeSetState({
                error: __("Please write a note before continuing without setting a reminder.")
            });
            return;
        }

        this.safeSetState({ loading: true, error: null });

        try {
            await axios.post("/business-notes", {
                business_id: businessId,
                note: note_text.trim()
            });

            this.props.onSaved?.();
        } catch (err) {
            this.safeSetState({ error: __("Something went wrong while saving the note.") });
        } finally {
            this.safeSetState({ loading: false });
        }
    };

    toggleNote = () => {
        this.safeSetState(prev => ({ noteShow: !prev.noteShow }));
    };

    renderContent = () => {
        const { noteShow, note_text, focused, error } = this.state;

        return (
            <div className="col-sm-12 mt-0 pl-0 pr-0 forward-history anim-slide-in-top">
                {error && <Alert alert={{ alert_class: "warning", alert_message: error, alert: true }} />}
                {__("You are adding a business note. You can set a reminder to come back to this business by selecting a future date and time, and notification method.")}
                <div className="row">
                    <div className="col-sm-12 mt-4">
                        <h5>{__("Choose Notification Date/Time")}</h5>
                        <div className="input-group feedback-form-control border">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="fas fa-calendar-alt" />
                                </span>
                            </div>
                            <input className="js-datetimepicker" type="date" name="datetime" required />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 mt-3"><h5>{__("Choose Notification Method")}</h5></div>
                    <div className="col-sm-4 d-flex align-items-center cursor-pointer">
                        <label className="mb-0 w-100 pb-1 pt-1 pl-2 pr-2 d-flex align-items-center border rounded">
                            <i className="fas text-primary fa-envelope mr-2" /> {__("Email")}
                            <input type="checkbox" className="ml-auto modal-email-checkbox" />
                        </label>
                    </div>
                    <div className="col-sm-4 d-flex align-items-center cursor-pointer">
                        <label className="mb-0 w-100 pb-1 pt-1 pl-2 pr-2 d-flex align-items-center border rounded">
                            <i className="fas text-primary fa-comments mr-2" /> {__("Text")}
                            <input type="checkbox" className="ml-auto modal-text-checkbox" />
                        </label>
                    </div>
                    <div className="col-sm-4 d-flex align-items-center cursor-pointer">
                        <label className="mb-0 w-100 pb-1 pt-1 pl-2 pr-2 d-flex align-items-center border rounded">
                            <i className="fas text-primary fa-bell mr-2" /> {__("Push")}
                            <input type="checkbox" className="ml-auto modal-push-checkbox" />
                        </label>
                    </div>
                    <div className="col-sm-12 mt-4 mb-4 text-right d-flex">
                        <button
                            onClick={this.toggleNote}
                            className={`btn ${this.state.noteShow ? "btn-primary" : "btn-outline-primary"} mr-3`}
                        >
                            {__("Add Note")}
                        </button>
                        <button
                            onClick={this.handleSubmit}
                            className="btn btn-primary reminder-button"
                            disabled={this.state.loading}
                        >
                            <i className="fas fa-clock mr-2" />
                            {__("Set Reminder and Continue")}
                        </button>
                    </div>
                    <div className="col-sm-12">
                        {noteShow && (
                            <textarea
                                onFocus={() => this.safeSetState({ focused: true })}
                                onBlur={() => this.safeSetState({ focused: false })}
                                value={note_text}
                                onChange={this.handleNoteTextChange}
                                className="note-textarea second-input input-primary w-100 grey-place"
                                rows={6}
                                placeholder={focused ? "" : __("Let your teammates know important things...")}
                            />
                        )}
                    </div>
                </div>
                <div className="col-sm-12 d-flex justify-content-between mt-4">
                    <button className="btn btn-outline-secondary" onClick={this.handleCancel}>
                        {__("Cancel")}
                    </button>
                    <button className="btn btn-outline-primary" onClick={this.handleContinueWithoutReminder}>
                        {__("Continue without setting a reminder")}
                    </button>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="modal fade show d-block bg-overlay" id="businessNoteReminderModal" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {__("Add Note or Reminder for ") + (this.props?.businessName || "N/A")}
                            </h5>
                            <button type="button" className="close" onClick={this.props.onClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.renderContent()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({ state });
export default connect(mapStateToProps)(BusinessNoteReminderModal);
